import clsx from "clsx";
import React from "react";
import { get, isNil } from "lodash";
import { useTranslation } from "react-i18next";

import PanelWrapper from "~/components/PanelWrapper";
import { DATA_STATUS_TYPES } from "~/constans/statuses";
import {
  useGetDealerInfoQuery,
  useGetProjectDocumentationDealerQuery,
} from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import s from "./BlockDealerShip.less";

const BlockDealerShip = ({
  isDoc,
  isArea,
}: {
  isDoc: boolean;
  isArea: boolean;
}) => {
  const { t } = useTranslation();
  const currentDealerId = useCurrentDealerId();
  const { data, loading } = useGetDealerInfoQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "cache-and-network",
    skip: !isArea,
  });

  const { SA, STOA, BSA, WA, TP } =
    get(data, "DealerGetter.getAreaDealer") || {};

  const projectQuery = useGetProjectDocumentationDealerQuery({
    variables: {
      DealerId: currentDealerId,
    },
    fetchPolicy: "no-cache",
    skip: !isDoc,
  });

  const project = get(
    projectQuery,
    "data.DealerGetter.getProjectDocumentationDealer",
    {},
  );

  return (
    <PanelWrapper
      width={780}
      height={70}
      label={t("dealership.dealership")}
      customClassName={s.dealership_label}
      loading={loading && projectQuery.loading}
    >
      <div className={s.dealer}>
        <ul className={s.dealer_list}>
          {project && (
            <li>
              <div className={s.wrapperProject}>
                <a
                  href={project?.File?.link}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  Проектная документация
                </a>
              </div>
            </li>
          )}
          <li>
            {t("dealership.market")}
            <div className={s.dealershipContainer}>
              <strong
                className={clsx(s.strong_value, {
                  [s.strong_value_green]: TP?.filled,
                })}
              >
                {(!isNil(TP?.area) && String(Math.round(Number(TP?.area)))) ||
                  DATA_STATUS_TYPES.ND}
              </strong>
              <strong
                className={clsx(s.strong_unit, {
                  [s.strong_unit_green]: TP?.filled,
                })}
              >
                {t("common.m")}
                <sup>2</sup>
              </strong>
            </div>
          </li>
          <li>
            {t("dealership.showroom")}
            <div className={s.dealershipContainer}>
              <strong
                className={clsx(s.strong_value, {
                  [s.strong_value_green]: SA?.filled,
                })}
              >
                {(!isNil(SA?.area) && String(Math.round(Number(SA?.area)))) ||
                  DATA_STATUS_TYPES.ND}
              </strong>
              <strong
                className={clsx(s.strong_unit, {
                  [s.strong_unit_green]: SA?.filled,
                })}
              >
                {t("common.m")}
                <sup>2</sup>
              </strong>
            </div>
          </li>
          <li>
            {t("dealership.workshop")}
            <div className={s.dealershipContainer}>
              <strong
                className={clsx(s.strong_value, {
                  [s.strong_value_green]: STOA?.filled,
                })}
              >
                {(!isNil(STOA?.area) &&
                  String(Math.round(Number(STOA?.area)))) ||
                  DATA_STATUS_TYPES.ND}
              </strong>
              <strong
                className={clsx(s.strong_unit, {
                  [s.strong_unit_green]: STOA?.filled,
                })}
              >
                {t("common.m")}
                <sup>2</sup>
              </strong>
            </div>
          </li>
          <li>
            {t("dealership.warehouse")}
            <div className={s.dealershipContainer}>
              <strong
                className={clsx(s.strong_value, {
                  [s.strong_value_green]: WA?.filled,
                })}
              >
                {(!isNil(WA?.area) && String(Math.round(Number(WA?.area)))) ||
                  DATA_STATUS_TYPES.ND}
              </strong>
              <strong
                className={clsx(s.strong_unit, {
                  [s.strong_unit_green]: WA?.filled,
                })}
              >
                {t("common.m")}
                <sup>2</sup>
              </strong>
            </div>
          </li>
          <li className={s.last}>
            {t("dealership.bodyshop")}
            <div className={s.dealershipContainer}>
              <strong
                className={clsx(s.strong_value, {
                  [s.strong_value_green]: BSA?.filled,
                })}
              >
                {(BSA &&
                  !isNil(BSA?.area) &&
                  String(Math.round(Number(BSA?.area)))) ||
                  DATA_STATUS_TYPES.ND}
              </strong>
              <strong
                className={clsx(s.strong_unit, {
                  [s.strong_unit_green]: BSA?.filled,
                })}
              >
                {t("common.m")}
                <sup>2</sup>
              </strong>
            </div>
          </li>
        </ul>
      </div>
    </PanelWrapper>
  );
};

export default BlockDealerShip;
